/**
 * Decimal places for percentage values in the attributes table.
 *
 * Numeric rather than string-valued (unlike AllocationMethod and DefaultMetricsGroup) so the member
 * can be handed straight to PercentValuePipe as its precision argument. The pipe's own default of 2
 * is deliberately left alone: Maps calls it with no argument in eight places and must keep rendering
 * as it does today.
 */
export enum PercentageDecimalPlaces {
    One = 1,
    Two = 2
}
